import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AddressConstants } from './address.constants';
import { CityResponse } from './models/city-response.model';

@Injectable({
	providedIn: 'root',
})
export class AddressService {
	states = AddressConstants.ufLabels;

	constructor(private readonly http: HttpClient) {}

	getCitiesByUfId(id: number): Observable<CityResponse[]> {
		const url = `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${id}/municipios`;

		return this.http.get<CityResponse[]>(url);
	}

	organizeCitiesByUfId(id: number, cities: CityResponse[]): string[] {
		const state = this.states.find((uf) => uf.id === id);
		const capital = cities.find((city) => city.nome === state?.capital);

		let newCities = cities
			.filter((city) => city.nome !== capital?.nome)
			.map((city) => city.nome);

		if (capital?.nome) {
			newCities = [capital.nome, ...newCities];
		}

		return newCities;
	}
}
